export type {
	FetchRequestTypeSuggestionAction,
	FetchRequestTypeSuggestionSuccess,
} from './request-type-suggestion';
export {
	FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL,
	FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS,
	fetchRequestTypeSuggestionAction,
	fetchRequestTypeSuggestionSuccess,
} from './request-type-suggestion';
